module.exports = __webpack_public_path__ + "static/media/digital.0f6fad80.png";